module.exports = __webpack_public_path__ + "img/logo-dark.7a60ba03.svg";